import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import BottomNav from './components/layout/BottomNav';
import Home from './pages/Home';
import Locator from './pages/Locator';
import Evento from './pages/Evento';
import EventDetail from './pages/EventDetail';
import Gallery from './pages/Gallery';

import CellShare from './pages/CellShare';
import CellPhotos from './pages/CellPhotos';
import Invite from './pages/Invite';
import Sobre from './pages/Sobre';
import Missoes from './pages/Missoes';
import Pregações from './pages/Pregações';
import Login from './pages/admin/Login';





import Dashboard from './pages/admin/Dashboard';
import ProtectedRoute from './pages/admin/ProtectedRoute';

function Shell() {
  const location = useLocation();
  const hideNav = location.pathname.startsWith('/admin');

  return (
    <div className="app-shell">
      <main className={hideNav ? '' : 'pb-24 md:pb-0'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/celulas" element={<Locator />} />
          <Route path="/evento" element={<Evento />} />
          <Route path="/evento/:id" element={<EventDetail />} />
          <Route path="/galeria" element={<Gallery />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/pregações" element={<Pregações />} />
          <Route path="/missoes" element={<Missoes />} />


          <Route path="/celula/:id/fotos" element={<CellPhotos />} />


          <Route path="/celula/:id" element={<CellShare />} />
          <Route path="/convite/:id" element={<Invite />} />


          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!hideNav && <BottomNav />}
    </div>
  );

}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
